import { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ApiService from '../../../../services/api';
import '../../css/course.css';
import parse from "html-react-parser";
import Facebook from '../../../../media/facebook.png';
import Twitter from '../../../../media/twitter.png';
import Pinterest from '../../../../media/pinterest.png';
import Linkedin from '../../../../media/linkedin.png';
import description from '../../../../media/description.png';
import goals from '../../../../media/goals.png';
import audience from '../../../../media/audience.png';
import structure from '../../../../media/structure.png';
import certificate from '../../../../media/certificate2.png';
import program from '../../../../media/program.png';
import review from '../../../../media/reviews.png';
import teachers from '../../../../media/teachers.png';
import Person from '../../../../media/person.png';
import Timer from '../../../../media/timer_3.png';
import { AuthContext } from '../../../../services/authContext';
import { confirmToast } from '../../../app/components/confirmToast';
import DOMPurify from "dompurify";

function Course() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useContext(AuthContext);

  const [course, setCourse] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [activeSection, setActiveSection] = useState("description");
  const [userCourses, setUserCourses] = useState(null);
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const courseData = await ApiService.getCourse(slug);
        setCourse(courseData);

        const reviewsData = await ApiService.getCourseReviews(courseData.slug);
        setReviews(reviewsData);
      } catch (err) {
        if (err.response?.status === 403) navigate("/", { replace: true });
        console.error(err);
      }
    };
    fetchData();
  }, [slug]);

  useEffect(() => {
    if (!isAuthenticated) return;

    const fetchUserCourses = async () => {
      try {
        const res = await ApiService.getMyCourses();
        setUserCourses(res);
      } catch (err) {
        console.error(err);
        setUserCourses([]);
      }
    };

    fetchUserCourses();
  }, [isAuthenticated]);

  if (!course) return null;

  const avgRating = course.avg_rating ? course.avg_rating / 2 : 0;
  const totalReviews = course.total_reviews || 0;

  const renderStars = (rating, clickable = false) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      let starClass = "empty2";
      if (i <= rating) starClass = "filled2";
      else if (i - rating <= 0.5) starClass = "half";
      stars.push(
        <span
          key={i}
          className={`star ${starClass} ${clickable ? "clickable" : "disabled"}`}
          onClick={clickable ? () => setActiveSection("reviews") : null}
        >
          ★
        </span>
      );
    }
    return stars;
  };

  const renderStars2 = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      let starClass = "empty";
      if (i <= rating) starClass = "filled";
      else if (i - rating <= 0.5) starClass = "half";
      stars.push(
        <span key={i} className={`star ${starClass}`}>
          ★
        </span>
      );
    }
    return stars;
  };

  const sections = [
    { key: "description", label: "Descrizione", content: course.description },
    { key: "goals", label: "Obiettivi", content: course.goals },
    { key: "audience", label: "Destinatari", content: course.audience },
    { key: "structure", label: "Struttura", content: course.course_structure },
    { key: "certificate", label: "Certificato", content: course.certificate },
    { key: "program", label: "Programma", content: course.course_program },
    { key: "teachers", label: "Docenti", content: course.teacher_data },
    { key: "reviews", label: "Recensioni", content: reviews },
  ].filter(s => s.content && (typeof s.content === "string" ? s.content.trim() !== "" : true));

  const getCourseButton = () => {
    if (!isAuthenticated) {
      return (
        <button className="enrollButton-new" onClick={() => navigate("/login")}>
          ACCEDI
        </button>
      );
    }

    if (loading || userCourses === null) return null;

    const userCourse = userCourses.find(c => c.id === course.id);

    if (userCourse && userCourse.frequentable) {
    
      return (
        <button
          className="enrollButton-new"
          onClick={() => {
            confirmToast({
              message: "Vuoi partecipare al corso? Una volta confermato inizierai lo svolgimento del programma.",
              confirmText: "Partecipa",
              onConfirm: () => navigate(`/course-content/${course.slug}`),
            });
          }}
        >
          PARTECIPA
        </button>
      );
    }

    return (
      <button className="enrollButton-new2" disabled>
        NON DISPONIBILE
      </button>
    );
  };

  const active = sections.find(s => s.key === activeSection);

  return (
    <div className="coursePageNew">
      <div className="courseDetail-container-new">

      
        <div className="course-hero-new">
          <div className="course-hero-left">
            <h1>{course.title}</h1>
          </div>

          <div className="course-hero-right">
            <img src={course.main_img} alt={course.title} />
          </div>
        </div>

      
        <div className="courseDetail-main-new">

          
          <div className="courseDetail-left-new">
            <div className="courseDetail-tabs-new">
              {sections.map((s) => (
                <button
                  key={s.key}
                  className={`tabButton-new ${activeSection === s.key ? "active-new" : ""}`}
                  onClick={() => setActiveSection(s.key)}
                >
                  {s.label}
                </button>
              ))}
            </div>

            <div className="courseDetail-sectionContentDisplay-new">
              {activeSection === "reviews" ? (
                reviews.length === 0 ? (
                  <p>Nessuna recensione disponibile.</p>
                ) : (
                  reviews.map((rev) => (
                    <div>
                      <div key={rev.id} className="reviewCard-new">
                        <img style={{width:"32px", height:"32px", marginTop:'10px'}} src={Person} alt="" />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginLeft: "10px",
                            gap:"10px"
                          }}
                        >
                          <p className="reviewUser-new">
                            Utente Actafad
                          </p>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center"
                            }}
                          >
                            <div className="reviewStars">
                              {renderStars2(rev.rating / 2)}
                            </div>

                            <p
                              style={{
                                margin: "0 0 0 10px"
                              }}
                            >
                              {new Date(rev.date).toLocaleDateString()}
                            </p>
                          </div>
                        </div>
                      </div>
                    {rev.comment ? (
                      <>
                        <p
                          style={{
                            borderRadius: "24px",
                            backgroundColor: "#f1f1f1",
                            padding: "20px"
                          }}
                        >
                          {rev.comment}
                        </p>
                        <p
                          style={{
                            borderRadius: "24px",
                            backgroundColor: "#f1f1f1",
                            padding: "1px"
                          }}
                        />
                      </>
                    ) : (
                      <p
                        style={{
                          borderRadius: "24px",
                          backgroundColor: "#f1f1f1",
                          padding: "1px"
                        }}
                      />
                    )}

                    </div>
                  ))
                )
              ) : activeSection === "teachers" ? (
                <div
                  className="courseDetail-teachersSection-new"
                  style={{ position: "relative" }}
                >
                  
                  {course.teacher_data.map((teacher) => (
                    <div
                      key={teacher.id}
                      className="courseDetail-teacherCard-new clickable"
                      onClick={() =>
                        setSelectedTeacher(
                          selectedTeacher?.id === teacher.id ? null : teacher
                        )
                      }
                    >
                      <img src={teacher.img_profile} alt={teacher.first_name} />
                      <h4>
                        {teacher.first_name} {teacher.last_name}
                      </h4>
                    </div>
                  ))}

                
                  {selectedTeacher && (
                    <div className="teacherFloatingPanel">
                      <button
                        className="teacherCloseInline"
                        onClick={() => setSelectedTeacher(null)}
                      >
                        ✕
                      </button>

                      <div className="teacherFloatingHeader">
                        <img
                          src={selectedTeacher.img_profile}
                          alt={selectedTeacher.first_name}
                        />

                        <div>
                          <h2>
                            {selectedTeacher.first_name} {selectedTeacher.last_name}
                          </h2>

                          <h4>{selectedTeacher.professional_qualification}</h4>
                        </div>
                      </div>

                      <div className="teacherFloatingContent">
                        {parse(DOMPurify.sanitize(
                          (selectedTeacher.about_me || ""))
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="tab-text-new">
                  {parse(DOMPurify.sanitize((active?.content || "")))}
                </div>
              )}
            </div>
          </div>

          
          <div className="courseDetail-right-new">
            <div className="courseSidebar-box">

              <div>
                <span>
                  <img
                    style={{
                      width: "32px",
                      height: "32px",
                      marginTop: "-5px",
                      marginRight: "10px"
                    }}
                    src={Timer}
                    alt=""
                  />

                  {course.my_total_duration
                    ? `${course.my_total_duration} ${
                        course.my_total_duration === 1 ? "ora" : "ore"
                      }`
                    : course.total_duration
                      ? course.total_duration < 60
                        ? `${course.total_duration} min`
                        : `${Math.floor(course.total_duration / 60)} ${
                            Math.floor(course.total_duration / 60) === 1 ? "ora" : "ore"
                          }`
                      : "0 min"}
                </span>
              </div>

              <div className="course-hero-rating-new">
                {renderStars(avgRating, true)}
                <span className="course-hero-rating-text">({totalReviews})</span>
              </div>


              <div className="course-hero-social-new">
                <strong>Condividi:</strong>

                <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noreferrer">
                  <img className="social-icon" src={Facebook} alt="Facebook" />
                </a>

                <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noreferrer">
                  <img className="social-icon" src={Twitter} alt="Twitter" />
                </a>

                <a href={`https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noreferrer">
                  <img className="social-icon" src={Pinterest} alt="Pinterest" />
                </a>

                <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`} target="_blank" rel="noreferrer">
                  <img className="social-icon" src={Linkedin} alt="Linkedin" />
                </a>
              </div>

               {getCourseButton()}

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Course;